import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=7f7bfc0c"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports